import { BrowserSessionApiClient } from "./browserSessionApiClient";
export type InvoiceSmsPolicy = { enabled: boolean; paused: boolean; disputed: boolean; timeZone: string | null };
export type SmsReviewItem = {
  id: number; status: string; reason: string | null; previewHash: string;
  canConfirm: boolean; canSkip: boolean; providerMessageId: string | null;
  invoicePolicy: InvoiceSmsPolicy | null;
  snapshot: {
    kind: "invoice" | "quotation"; company: string; entityId: number; source: string; stage: 14 | 30 | null;
    reference: string; project: string; client: string; dueDate: string | null; overdueDays: number | null;
    balance: number | null; recipientName: string; recipientKey: string; recipientPhone: string | null;
    body: string; timeZone: string; timeZoneRule: string; blockReason: string | null;
  };
};
export type SmsReviewList = { items: SmsReviewItem[]; provider: string; asOf: string; timeZone: string; limit: number };
const base = (import.meta.env.VITE_API_BASE_URL || "/api").replace(/\/+$/, "");
const client = new BrowserSessionApiClient(base);
async function request<T>(path: string, method = "GET", body?: unknown): Promise<T> {
  const response = await client.request<{ data: T }>(`${base}/v1/sms/reviews${path}`, { method, ...(body ? { body } : {}) });
  return response.data;
}
export const smsReviewService = {
  list: () => request<SmsReviewList>(""),
  scan: () => request<{ prepared: number }>("/scan", "POST", {}),
  act: (id: number, action: "confirm" | "skip", previewHash: string) => request<{ outcome: string }>(`/${id}/${action}`, "POST", { previewHash }),
  policy: (id: number, policy: InvoiceSmsPolicy) => request(`/${id}/policy`, "PUT", policy),
};
